export const defaultConfirmationPaneConfirmButtonHoveredStyles = {
  backgroundColor: "rgba(9,72,159,0.8)"
};